var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOscuro(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 21,
    viewBox: "0 0 144 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.824 5.16797C141.072 5.16797 142.062 5.54597 142.794 6.30197C143.538 7.05797 143.91 8.10797 143.91 9.45197V15.32H140.85V9.86597C140.85 9.21797 140.676 8.71997 140.328 8.37197C139.992 8.01197 139.524 7.83197 138.924 7.83197C138.324 7.83197 137.85 8.01197 137.502 8.37197C137.166 8.71997 136.998 9.21797 136.998 9.86597V15.32H133.938V9.86597C133.938 9.21797 133.764 8.71997 133.416 8.37197C133.08 8.01197 132.612 7.83197 132.012 7.83197C131.412 7.83197 130.938 8.01197 130.59 8.37197C130.254 8.71997 130.086 9.21797 130.086 9.86597V15.32H127.008V5.27597H130.086V6.53597C130.398 6.11597 130.806 5.78597 131.31 5.54597C131.814 5.29397 132.384 5.16797 133.02 5.16797C133.776 5.16797 134.448 5.32997 135.036 5.65397C135.636 5.97797 136.104 6.43997 136.44 7.03997C136.788 6.48797 137.262 6.03797 137.862 5.68997C138.462 5.34197 139.116 5.16797 139.824 5.16797Z",
    fill: "url(#paint0_linear_345_59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.384 10.1358C125.384 10.4238 125.366 10.7238 125.33 11.0358H118.364C118.412 11.6598 118.61 12.1398 118.958 12.4758C119.318 12.7998 119.756 12.9618 120.272 12.9618C121.04 12.9618 121.574 12.6378 121.874 11.9898H125.15C124.982 12.6498 124.676 13.2438 124.232 13.7718C123.8 14.2998 123.254 14.7138 122.594 15.0138C121.934 15.3138 121.196 15.4638 120.38 15.4638C119.396 15.4638 118.52 15.2538 117.752 14.8338C116.984 14.4138 116.384 13.8138 115.952 13.0338C115.52 12.2538 115.304 11.3418 115.304 10.2978C115.304 9.25384 115.514 8.34184 115.934 7.56184C116.366 6.78184 116.966 6.18184 117.734 5.76184C118.502 5.34184 119.384 5.13184 120.38 5.13184C121.352 5.13184 122.216 5.33584 122.972 5.74384C123.728 6.15184 124.316 6.73384 124.736 7.48984C125.168 8.24584 125.384 9.12784 125.384 10.1358ZM122.234 9.32584C122.234 8.79784 122.054 8.37784 121.694 8.06584C121.334 7.75384 120.884 7.59784 120.344 7.59784C119.828 7.59784 119.39 7.74784 119.03 8.04784C118.682 8.34784 118.466 8.77384 118.382 9.32584H122.234Z",
    fill: "url(#paint1_linear_345_59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.201 12.7101V15.3201H112.635C111.519 15.3201 110.649 15.0501 110.025 14.5101C109.401 13.9581 109.089 13.0641 109.089 11.8281V7.83209H107.865V5.27609H109.089V2.82812H112.167V5.27609H114.183V7.83209H112.167V11.8641C112.167 12.1641 112.239 12.3801 112.383 12.5121C112.527 12.6441 112.767 12.7101 113.103 12.7101H114.201Z",
    fill: "url(#paint2_linear_345_59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.652 15.4638C101.776 15.4638 100.996 15.3138 100.312 15.0138C99.6279 14.7138 99.0879 14.3058 98.6919 13.7898C98.2959 13.2618 98.0739 12.6738 98.0259 12.0258H101.068C101.104 12.3738 101.266 12.6558 101.554 12.8718C101.842 13.0878 102.196 13.1958 102.616 13.1958C103 13.1958 103.294 13.1238 103.498 12.9798C103.714 12.8238 103.822 12.6258 103.822 12.3858C103.822 12.0978 103.672 11.8878 103.372 11.7558C103.072 11.6118 102.586 11.4558 101.914 11.2878C101.194 11.1198 100.594 10.9458 100.114 10.7658C99.6339 10.5738 99.2199 10.2798 98.8719 9.88384C98.5239 9.47584 98.3499 8.92984 98.3499 8.24584C98.3499 7.66984 98.5059 7.14784 98.8179 6.67984C99.1419 6.19984 99.6099 5.82184 100.222 5.54584C100.846 5.26984 101.584 5.13184 102.436 5.13184C103.696 5.13184 104.686 5.44384 105.406 6.06784C106.138 6.69184 106.558 7.51984 106.666 8.55184H103.822C103.774 8.20384 103.618 7.92784 103.354 7.72384C103.102 7.51984 102.766 7.41784 102.346 7.41784C101.986 7.41784 101.71 7.48984 101.518 7.63384C101.326 7.76584 101.23 7.95184 101.23 8.19184C101.23 8.47984 101.38 8.69584 101.68 8.83984C101.992 8.98384 102.472 9.12784 103.12 9.27184C103.864 9.46384 104.47 9.65584 104.938 9.84784C105.406 10.0278 105.814 10.3278 106.162 10.7478C106.522 11.1558 106.708 11.7078 106.72 12.4038C106.72 12.9918 106.552 13.5198 106.216 13.9878C105.892 14.4438 105.418 14.8038 104.794 15.0678C104.182 15.3318 103.468 15.4638 102.652 15.4638Z",
    fill: "url(#paint3_linear_345_59)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.453 5.27637L91.153 20.0904H87.8411L90.145 14.9784L86.0591 5.27637H89.4971L91.819 11.5584L94.123 5.27637H97.453Z",
    fill: "url(#paint4_linear_345_59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6908 15.4459C79.7668 15.4459 78.9388 15.2959 78.2068 14.9959C77.4748 14.6959 76.8868 14.2519 76.4428 13.6639C76.0108 13.0759 75.7828 12.3679 75.7588 11.5399H79.0348C79.0828 12.0079 79.2448 12.3679 79.5208 12.6199C79.7968 12.8599 80.1568 12.9799 80.6008 12.9799C81.0568 12.9799 81.4168 12.8779 81.6808 12.6739C81.9448 12.4579 82.0768 12.1639 82.0768 11.7919C82.0768 11.4799 81.9688 11.2219 81.7528 11.0179C81.5488 10.8139 81.2908 10.6459 80.9788 10.5139C80.6788 10.3819 80.2468 10.2319 79.6828 10.0639C78.8668 9.8119 78.2008 9.5599 77.6848 9.3079C77.1688 9.0559 76.7248 8.6839 76.3528 8.1919C75.9808 7.6999 75.7948 7.0579 75.7948 6.2659C75.7948 5.0899 76.2208 4.1719 77.0728 3.51191C77.9248 2.83991 79.0348 2.50391 80.4028 2.50391C81.7948 2.50391 82.9168 2.83991 83.7688 3.51191C84.6208 4.1719 85.0768 5.0959 85.1368 6.2839H81.8068C81.7828 5.8759 81.6328 5.5579 81.3568 5.3299C81.0808 5.0899 80.7268 4.9699 80.2948 4.9699C79.9228 4.9699 79.6228 5.0719 79.3948 5.2759C79.1668 5.4679 79.0528 5.7499 79.0528 6.1219C79.0528 6.5299 79.2448 6.8479 79.6288 7.0759C80.0128 7.3039 80.6128 7.5499 81.4288 7.8139C82.2448 8.0899 82.9048 8.3539 83.4088 8.6059C83.9248 8.8579 84.3688 9.2239 84.7408 9.7039C85.1128 10.1839 85.2988 10.8019 85.2988 11.5579C85.2988 12.2779 85.1128 12.9319 84.7408 13.5199C84.3808 14.1079 83.8528 14.5759 83.1568 14.9239C82.4608 15.2719 81.6388 15.4459 80.6908 15.4459Z",
    fill: "url(#paint5_linear_345_59)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4154 15.4638C64.4314 15.4638 63.5434 15.2538 62.7514 14.8338C61.9714 14.4138 61.3534 13.8138 60.8974 13.0338C60.4534 12.2538 60.2314 11.3418 60.2314 10.2978C60.2314 9.26584 60.4594 8.35984 60.9154 7.57984C61.3714 6.78784 61.9954 6.18184 62.7874 5.76184C63.5794 5.34184 64.4674 5.13184 65.4514 5.13184C66.4354 5.13184 67.3234 5.34184 68.1154 5.76184C68.9074 6.18184 69.5314 6.78784 69.9874 7.57984C70.4434 8.35984 70.6714 9.26584 70.6714 10.2978C70.6714 11.3298 70.4374 12.2418 69.9694 13.0338C69.5134 13.8138 68.8834 14.4138 68.0794 14.8338C67.2874 15.2538 66.3994 15.4638 65.4154 15.4638ZM65.4154 12.7998C66.0034 12.7998 66.5014 12.5838 66.9094 12.1518C67.3294 11.7198 67.5394 11.1018 67.5394 10.2978C67.5394 9.49384 67.3354 8.87584 66.9274 8.44384C66.5314 8.01184 66.0394 7.79584 65.4514 7.79584C64.8514 7.79584 64.3534 8.01184 63.9574 8.44384C63.5614 8.86384 63.3634 9.48184 63.3634 10.2978C63.3634 11.1018 63.5554 11.7198 63.9394 12.1518C64.3354 12.5838 64.8274 12.7998 65.4154 12.7998Z",
    fill: "url(#paint6_linear_345_59)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.705 6.698C51.993 6.23 52.407 5.852 52.947 5.564C53.487 5.276 54.105 5.132 54.801 5.132C55.629 5.132 56.379 5.342 57.051 5.762C57.723 6.182 58.251 6.782 58.635 7.562C59.031 8.342 59.229 9.248 59.229 10.28C59.229 11.312 59.031 12.224 58.635 13.016C58.251 13.796 57.723 14.402 57.051 14.834C56.379 15.254 55.629 15.464 54.801 15.464C54.093 15.464 53.475 15.326 52.947 15.05C52.419 14.762 52.005 14.384 51.705 13.916V15.32H48.627V2H51.705V6.698ZM56.097 10.28C56.097 9.512 55.881 8.912 55.449 8.48C55.029 8.036 54.507 7.814 53.883 7.814C53.271 7.814 52.749 8.036 52.317 8.48C51.897 8.924 51.687 9.53 51.687 10.298C51.687 11.066 51.897 11.672 52.317 12.116C52.749 12.56 53.271 12.782 53.883 12.782C54.495 12.782 55.017 12.56 55.449 12.116C55.881 11.66 56.097 11.048 56.097 10.28Z",
    fill: "url(#paint7_linear_345_59)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0028 10.1358C47.0028 10.4238 46.9848 10.7238 46.9488 11.0358H39.9828C40.0308 11.6598 40.2289 12.1398 40.5769 12.4758C40.9369 12.7998 41.3749 12.9618 41.8909 12.9618C42.6589 12.9618 43.1929 12.6378 43.4929 11.9898H46.7689C46.6009 12.6498 46.2948 13.2438 45.8508 13.7718C45.4188 14.2998 44.8728 14.7138 44.2128 15.0138C43.5528 15.3138 42.8149 15.4638 41.9989 15.4638C41.0149 15.4638 40.1388 15.2538 39.3708 14.8338C38.6028 14.4138 38.0029 13.8138 37.5709 13.0338C37.1389 12.2538 36.9229 11.3418 36.9229 10.2978C36.9229 9.25384 37.1328 8.34184 37.5528 7.56184C37.9848 6.78184 38.5849 6.18184 39.3529 5.76184C40.1209 5.34184 41.0029 5.13184 41.9989 5.13184C42.9709 5.13184 43.8349 5.33584 44.5909 5.74384C45.3469 6.15184 45.9349 6.73384 46.3549 7.48984C46.7869 8.24584 47.0028 9.12784 47.0028 10.1358ZM43.8529 9.32584C43.8529 8.79784 43.6729 8.37784 43.3129 8.06584C42.9529 7.75384 42.5028 7.59784 41.9628 7.59784C41.4468 7.59784 41.0088 7.74784 40.6488 8.04784C40.3008 8.34784 40.0849 8.77384 40.0009 9.32584H43.8529Z",
    fill: "url(#paint8_linear_345_59)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.304 15.3196H32.226L27.078 7.5256V15.3196H24V2.68359H27.078L32.226 10.5136V2.68359H35.304V15.3196Z",
    fill: "url(#paint9_linear_345_59)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38817 0H0V17L17 0H12.1198L3.49675 8.5191V3.84994L7.38817 0Z",
    fill: "url(#paint10_linear_345_59)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16475 13.4684L4.70195 17H17V4.5588L13.5372 8.02247V13.4684H8.16475Z",
    fill: "url(#paint11_linear_345_59)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_345_59",
    x1: 22.415,
    y1: 8.81977,
    x2: 145.415,
    y2: 8.81977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_345_59",
    x1: 22.4149,
    y1: 8.81983,
    x2: 145.415,
    y2: 8.81983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_345_59",
    x1: 22.415,
    y1: 8.82029,
    x2: 145.415,
    y2: 8.82029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_345_59",
    x1: 22.4149,
    y1: 8.81983,
    x2: 145.415,
    y2: 8.81983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_345_59",
    x1: 22.4149,
    y1: 8.82027,
    x2: 145.415,
    y2: 8.82027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_345_59",
    x1: 22.415,
    y1: 8.81979,
    x2: 145.415,
    y2: 8.81979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_345_59",
    x1: 22.415,
    y1: 8.81983,
    x2: 145.415,
    y2: 8.81983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_345_59",
    x1: 22.415,
    y1: 8.8198,
    x2: 145.415,
    y2: 8.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_345_59",
    x1: 22.415,
    y1: 8.81983,
    x2: 145.415,
    y2: 8.81983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_345_59",
    x1: 22.415,
    y1: 8.8198,
    x2: 145.415,
    y2: 8.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_345_59",
    x1: 8.5,
    y1: 0,
    x2: 8.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_345_59",
    x1: 8.5,
    y1: 0,
    x2: 8.5,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOscuro);
export default __webpack_public_path__ + "static/media/logo_oscuro.54ed66ed5faa954344a5f37c07fa1d14.svg";
export { ForwardRef as ReactComponent };